import { toEDNStringFromSimpleObject } from "edn-data";
import { queryOmegaSingleResult } from "../../api";
import { PageView } from "../../types/notebook/view";

// Typescript wrapper for https://github.com/The-Lambda-Group/query-omega-oql/blob/development/oql/app/public/api/page/view.oql

/**
 * Get Page Views
 * @param pageId the database of which to add the property to
 * @param appId workspace ID
 */
export const getDatabaseViews: (config: {
  "page-id": string;
  "app-id": string;
}) => Promise<PageView[]> = async (request) => {
  const ednString = toEDNStringFromSimpleObject(request as any, {
    keysAs: "string",
  });
  const query = `
        (datastore Qo.Public.Api.Page.View "omega/query-omega/public/api/page/view")
        (Qo.Public.Api.Page.View/page-views ${ednString} Response)
        (return [Response])
    `;
  const response = await queryOmegaSingleResult(query);
  return response;
};

/**
 * Add Databse View
 * @param pageId the database of which to add the property to
 * @param appId workspace ID
 */
export const addDatabaseView: (view: PageView) => Promise<PageView> = async (
  view
) => {
  const ednString = toEDNStringFromSimpleObject(view as any, {
    keysAs: "string",
  });
  const query = `
        (datastore Qo.Public.Api.Page.View "omega/query-omega/public/api/page/view")
        (Qo.Public.Api.Page.View/add-page-view ${ednString} Response)
        (return [Response])
    `;
  const response = await queryOmegaSingleResult(query);
  return response;
};

/**
 * Delete a Database View
 * @param viewId the view ID to delete
 * @param appId workspace ID
 */
export const deleteDatabaseView: (config: {
  "app-id": string;
  "view-id": string;
}) => Promise<PageView> = async (config) => {
  const ednString = toEDNStringFromSimpleObject(config as any, {
    keysAs: "string",
  });
  const query = `
        (datastore Qo.Public.Api.Page.View "omega/query-omega/public/api/page/view")
        (Qo.Public.Api.Page.View/delete-page-view ${ednString} Response)
        (return [Response])
    `;
  const response = await queryOmegaSingleResult(query);
  return response;
};

/**
 * Edit a database view
 * @param viewId the view ID to delete
 * @param appId workspace ID
 * @param viewData the new view data
 */
export const editDatabaseView: (view: PageView) => Promise<PageView> = async (
  view
) => {
  const ednString = toEDNStringFromSimpleObject(view as any, {
    keysAs: "string",
  });
  const query = `
        (datastore Qo.Public.Api.Page.View "omega/query-omega/public/api/page/view")
        (Qo.Public.Api.Page.View/update-page-view ${ednString} Response)
        (return [Response])
    `;
  const response = await queryOmegaSingleResult(query);
  return response;
};

/**
 * Swap two database views
 */
export const swapDatabaseViews: (config: {
  "app-id": string;
  "page-id": string;
  "active-view-id": string;
  "over-view-id": string;
}) => Promise<PageView> = async (config) => {
  const ednString = toEDNStringFromSimpleObject(config as any, {
    keysAs: "string",
  });
  const query = `
        (datastore Qo.Public.Api.Page.View "omega/query-omega/public/api/page/view")
        (Qo.Public.Api.Page.View/swap-page-views ${ednString} Response)
        (return [Response])
    `;
  const response = await queryOmegaSingleResult(query);
  return response;
};
